import { LinkModel } from './LinkModel';

export function RenderLinkTitle(link: LinkModel) {
  switch (link.Type) {
    case 'ORDER-INVOICE_DOWNLOAD':
      return `Download \n Invoice`;
    case 'ORDER-PROTECTION_PAGE':
      return `Add \n Extras`;
    case 'ORDER-OPENCLAIM_PAGE':
      return 'Open Enquiry';
    default:
      return link.Label;
  }
}

export function GetLinkDescription(link: LinkModel) {
  switch (link.Type) {
    case 'ORDER-REBOOK_PAGE':
      return 'Fast and reliable way to reschedule your collection.';

    case 'ORDER-PICKINGLIST_DOWNLOAD':
      return 'Match parcel contents to labels with a downloadable picking list.';

    case 'RAISE-ENQUIRY_ONCLICK':
    case 'ORDER-OPENCLAIM_PAGE':
      return 'If there is an issue with your delivery, click here to open an enquiry.';

    case 'ORDER-EDITDETAILS_PAGE':
      return 'Change the information of your parcel before sending it.';

    case 'ORDER-INVOICE_DOWNLOAD':
      return 'Download an invoice for this order. Once you have clicked, it will download automatically.';

    case 'CANCEL_ONCLICK':
    case 'CANCELLATION_PAGE':
      return 'If you no longer need to send your parcel you can cancel and enjoy quicker refunds.';

    case 'BUY-AGAIN_ONCLICK':
      return 'Duplicate this order to buy again. All order details will be replicated.';

    case 'ARRANGE-RETURN_ONCLICK':
      return `Arrange a Return. By clicking here, an order will be created and added to 'New Orders'.`;

    case 'MARKDISPATCHED_ONCLICK':
      return `Update the marketplace with tracking numbers.`;

    case 'MARKDISPATCHED_RETRY_ONCLICK':
      return `Retry updating the marketplace with tracking numbers.`;

    case 'MARKDISPATCHED_PROGRESS':
      return `Updating the marketplace with tracking numbers.`;

    case 'MARKPACKAGED_ONCLICK':
      return `Parcel has been packed and is ready to be collected or dropped off.`;

    case 'GOTO-BOOKED_ONCLICK':
      return `Once you've booked your orders, you can manage them witin the 'Order History' panel on the dashboard.`;

    case 'GOTO-PICKANDPACK_ONCLICK':
      return `More pick and packing tools.`;

    case 'GOTO-MANIFESTS':
      return `Manifest your orders at anytime. Look out for the prompt which will appear above your orders, or follow this link.`;

    default:
      return link.Label;
  }
}
